import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, List, LoadingController } from 'ionic-angular';
import { AuthenticationApi } from '../../services/authentication/authentication-api';
import { CustomersService } from '../../services/customers/customers-service';
import { Customer } from '../../models/customer';
import { CustomerTabsPage } from '../customer-tabs/customer-tabs';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-customer',
  templateUrl: 'customers.html'
})
export class CustomersPage {
  @ViewChild(List) list: List;
  selectedCustomer: any;
  originalCustomers: Array<Customer>;
  Customers: Array<Customer>;

  ionViewCanEnter() {
    if( !this.authApi.isAuthenticated() ) {
      this.navCtrl.setRoot(LoginPage);
    }
    else {
      return true;
    }
  }

  toCamelCase(str): string {
    return str.split("_").map(function(word,index){

      // If it is the first word make sure to lowercase all the chars.
      if(index == 0) {
        return String(word).toLowerCase();
      }

      // If it is not the first word only upper case the first char and lowercase the rest.
      return String(word).charAt(0).toUpperCase() + String(word).slice(1).toLowerCase();

    }).join("");
  }

  setSelectedCustomer() {
    // If we navigated to this page, we will have an item available as a nav param
    this.selectedCustomer = this.navParams.get("Customer");
  }

  alertError(err?: string) {
    let alert = this.alertCtrl.create({
      title: 'Error',
      subTitle: err ? err : 'There was an error attempting to reach the server.  Please check your inputs & try again.',
      buttons: ['Dismiss']
    });
    alert.present();
  }

  // V2 Updated.
  customerSelected(event, SelectedCustomer) {

    // create loading alert instance.
    let loading = this.loadingCtrl.create({ content: "Loading Customer..." });

    // turn on loading notification.
    loading.present();

    // fetch selected customer record w/ related data records.
    this.custService
          .getById(SelectedCustomer.get("id"),{_related: ["Events", "Invoices"], _meta: true})
          .subscribe(

            // Handle Success Response
            res => {

              let self: CustomersPage = this;
              let o: object = {};

              // Instantiate Customer model w/ response data.
              for(var e in res){ o[self.toCamelCase(e)] = res[e]; }
              let Cust: Customer = new Customer(o);

              // shut off loading notification.
              loading.dismiss();

              // set the active customer model.
              this.custService.set(Cust); 

              // load the CustomerTabsPage w/ the attached Cust instance.
              this.navCtrl.push(CustomerTabsPage, {Customer: Cust});
            },

            // Handle Request Rejection.
            rej => {
              try { loading.dismiss(); this.alertError(rej.error.message); }
              catch(ex) { loading.dismiss(); this.alertError(); }
            }
          );
  }

  customerSearch(searchEvent) {
    let term = searchEvent.target.value ? String(searchEvent.target.value) : false;

    if( term && term.trim().length >= 3 )
    {
      // get customer search results
      let self: CustomersPage = this;
      this.custService.search({global: term}).subscribe(res => {
        let Customers: Customer[] = res.map(function(c){
          // change to camelCase
          let o: object = {};
          for(var e in c){ o[self.toCamelCase(e)] = c[e]; }
          return new Customer(o);
        });

        this.Customers = Customers;
      });
    }

    else
    {
      // set cached customers.
      this.Customers = this.originalCustomers;
    }
  }

  constructor(private navCtrl: NavController,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private authApi: AuthenticationApi,
    private loadingCtrl: LoadingController,
    private custService: CustomersService) {

      let loading = this.loadingCtrl.create({
        content: "Fetching Customer List..."
      });

      loading.present();

      let self: CustomersPage = this;
      this.custService.all().subscribe(res => {
        let Customers: Customer[] = res.map(function(c){
          // change to camelCase
          let o: object = {};
          for(var e in c){ o[self.toCamelCase(e)] = c[e]; }
          return new Customer(o);
        });

        this.Customers = Customers;
        this.originalCustomers = Customers;

        loading.dismiss();
      });

      this.setSelectedCustomer();
  }

}



// WEBPACK FOOTER //
// ./src/pages/customers/customers.ts